module.exports = __webpack_public_path__ + "fonts/Quicksand-Medium.74eb5c1.ttf";